import { motion } from 'framer-motion';

const projects = [
  {
    category: 'Rénovation Complète',
    title: 'Réparation complète fenêtres appartement Chartrons',
    image: 'https://public.readdy.ai/ai/img_res/78133ca0825410cdc995c9e4b5273bba.jpg'
  },
  {
    category: 'Double Vitrage',
    title: 'Remplacement double vitrage maison Caudéran',
    image: 'https://readdy.ai/api/search-image?query=double%20glazed%20window%20replacement%20repair%20in%20modern%20house%20with%20simple%20neutral%20background%20clean%20white%20walls%20professional%20window%20repair%20service%20high%20quality%20craftsmanship&width=600&height=500&seq=portfolio-cauderan-repair-2&orientation=landscape'
  },
  {
    category: 'Baie Vitrée',
    title: 'Réparation baie vitrée villa Pessac',
    image: 'https://readdy.ai/api/search-image?query=large%20sliding%20glass%20door%20bay%20window%20repair%20in%20contemporary%20villa%20with%20simple%20clean%20background%20minimal%20decor%20bright%20natural%20light%20professional%20repair%20work&width=600&height=700&seq=portfolio-pessac-repair-3&orientation=portrait'
  },
  {
    category: 'Volet Roulant',
    title: 'Réparation volet roulant Mérignac',
    image: 'https://readdy.ai/api/search-image?query=roller%20shutter%20repair%20in%20modern%20home%20with%20clean%20simple%20background%20professional%20window%20shutter%20fixing%20service%20bright%20interior%20minimal%20setting&width=600&height=500&seq=portfolio-merignac-repair-4&orientation=landscape'
  },
  {
    category: 'Dépannage Urgence',
    title: 'Dépannage urgence centre Bordeaux',
    image: 'https://readdy.ai/api/search-image?query=emergency%20window%20repair%20service%20professional%20glazier%20working%20on%20broken%20window%20with%20simple%20clean%20background%20tools%20and%20equipment%20quality%20workmanship&width=600&height=750&seq=portfolio-bordeaux-repair-5&orientation=portrait'
  },
  {
    category: 'Isolation Phonique',
    title: 'Réparation isolation phonique immeuble Bastide',
    image: 'https://readdy.ai/api/search-image?query=soundproof%20windows%20repair%20in%20apartment%20building%20modern%20acoustic%20glazing%20with%20simple%20clean%20background%20professional%20repair%20work%20quiet%20peaceful%20interior&width=600&height=550&seq=portfolio-bastide-repair-6&orientation=landscape'
  }
];

export function Portfolio() {
  return (
    <section id="portfolio" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="inline-block bg-orange/10 text-orange px-6 py-2 rounded-full text-sm font-semibold mb-6">
            NOS RÉALISATIONS
          </div>
          <h2 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
            Découvrez Nos Projets<br />
            de Réparation Récents
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {projects.map((project, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              whileHover={{ scale: 1.02, boxShadow: '0 12px 32px rgba(0,0,0,0.12)' }}
              className="bg-white rounded-[20px] overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-80 w-full overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
              </div>
              <div className="p-8">
                <div className="inline-block bg-teal/15 text-teal-dark px-4 py-1 rounded-full text-sm font-semibold mb-4">
                  {project.category}
                </div>
                <h3 className="text-xl font-bold text-gray-900 leading-snug">
                  {project.title}
                </h3>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}